import Blank from '@/components/Layout/Blank'
import ForgotPassword from '@/components/Auth/ForgotPassword'
import Login from '@/components/Auth/Login'
import ResetPassword from '@/components/Auth/ResetPassword'
import FachstellenSignup from '@/components/Auth/FachstellenSignup'
import FachstellenConfirm from '@/components/Auth/FachstellenConfirm'
export default [{
	path: '/',
    redirect: '/login',
    component: Blank,
	children: [{
			path: '/login',
			name: 'Login',
			component: Login
		},
		{
			path: '/forgot-pass',
			name: 'ForgotPassword',
			component: ForgotPassword
        },
        {
			path: '/password/reset/:token',
			name: 'ResetPassword',
			component: ResetPassword
		},
		{
			path: '/fachstellen-signup/:token',
			name: 'FachstellenSignup',
			component: FachstellenSignup
		},
		{
			path: '/fachstellen-confirm/:token',
			name: 'FachstellenConfirm',
			component: FachstellenConfirm
		}
	]
}]



// WEBPACK FOOTER //
// ./src/components/Auth/router.js